<template lang="pug">
  .bottom_notification_wrap(:id="id")
    h3 {{ title }}
    p {{ text }}
    .close(@click="CloseNotification(id)")
</template>

<script>
export default {
  name: "NotifiCation",
  props: {
    text: String,
    title: String,
    id: String,
  },
  data () {
    return {
      delay: 10000,
      notifyTimeout: null
    }
  },
  mounted() {
    // setTimeout(this.showNotification, 1000);
  },
  methods: {
    showNotification(id) {
      this.removeAllOld();
      const bottom_notification_wrap = document.getElementById(id);
      bottom_notification_wrap.style.display = "block";
      setTimeout(() => bottom_notification_wrap.classList.add("active"), 10);
      this.notifyTimeout = setTimeout(() => bottom_notification_wrap.classList.remove("active"), this.delay);
    },
    removeAllOld() {
      if (this.notifyTimeout) {
        clearTimeout(this.notifyTimeout);
        const bottom_notification_wrap = document.getElementsByClassName("bottom_notification_wrap");
        for (let current_wrap of bottom_notification_wrap) {
          current_wrap.classList.remove("active");
        }
      }
    },
    CloseNotification(id) {
      // this.removeAllOld();
      const bottom_notification_wrap = document.getElementById(id);
      bottom_notification_wrap.classList.remove("active");
      setTimeout(() => bottom_notification_wrap.style.display = "none", 500);
    }
  }
}
</script>

<style lang="sass">
  .bottom_notification_wrap
    width: 320px
    min-height: 30px
    padding: 10px 10px 11px 15px
    opacity: 0
    display: none
    position: relative
    border-radius: 5px
    overflow: hidden
    transition: all 0.3s ease
    box-shadow: 0px 4px 4px 0px #00000040
    text-align: left
    background-color: #fff
    margin-bottom: 3px
    h3
      font-size: 16px
      font-weight: 600
      color: #E3AD24
      margin-bottom: 5px
    p
      font-size: 14px
      font-weight: 400
      margin: 0
    &:before
      display: block
      content: ""
      width: 8px
      height: 100%
      position: absolute
      top: 0
      left: 0
      background-color: #E3AD24
    .close
      width: 18px
      height: 18px
      position: absolute
      top: 8px
      right: 6px
      transform: rotate(45deg)
      cursor: pointer
      &:before, &:after
        display: block
        content: ""
        position: absolute
        background-color: #D4D4D4
      &:before
        width: 13px
        height: 1px
        top: 8px
        left: 2px
      &:after
        width: 1px
        height: 13px
        top: 2px
        left: 8px

  .bottom_notification_wrap.active
    opacity: 1

</style>
